import {
  ListAlertsPayload,
  ListAlertsQueryPayload,
} from '@src/entities/Alert/api/requests/queries/ListAlerts/includes/types';

export const DefaultListAlertsPayload: ListAlertsPayload = {
  page: 0,
  size: 25,
  sort: 'lastModifiedDate,desc',
};

export const DefaultListEventsQueryPayload: ListAlertsQueryPayload = ['Alert', 'ListAlerts', DefaultListAlertsPayload];
